import { type CSSProperties } from 'react';
import { kebabCase } from 'es-toolkit';

export const linkStyles: CSSProperties = {
  alignContent: 'center',
  alignItems: 'center',
  animation: 'none',
  background: 'rgba(251, 251, 251, 0.9)',
  border: 'none',
  borderRadius: '2px',
  bottom: '0',
  boxSizing: 'border-box',
  color: '#333333',
  display: 'flex',
  float: 'none',
  fontFamily: 'Roboto,Arial,Sans-serif',
  fontSize: '12px',
  height: 'auto',
  left: '0',
  lineHeight: '16px',
  margin: '0',
  opacity: '1',
  padding: '0',
  position: 'absolute',
  right: '0',
  textAlign: 'left',
  textDecoration: 'none',
  textIndent: '0',
  top: '0',
  transform: 'none',
  justifyContent: 'center',
  visibility: 'visible',
  zoom: '1',
  zIndex: '999999998'
};

export function markStylesImportant(objStyles: CSSProperties) {
  return Object.fromEntries(
    Object.entries(objStyles).map(([key, value]) => [key, `${value}!important`])
  );
}

export function toInlineStyles(style: CSSProperties) {
  return Object.entries(style)
    .map(([key, value]) => `${kebabCase(key)}:${value}`)
    .join(';');
}

export function setStyleAttribute(
  el: SVGSVGElement | HTMLElement | null,
  style: CSSProperties
) {
  if (el) {
    el.setAttribute('style', toInlineStyles(markStylesImportant(style)));
  }
}
